import { Section, Eyebrow } from "@/components/kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion";
import { ActDialogue } from "@/components/ActDialogue";
import { ACTS } from "@/data/content";

// Experiencia equivalente por episodio para el público:
// muestra los 6 actos del formato con lo que diría Bella y Anto en cada uno.
export const FormatDialogueSection = ({
  accent = "#A8E6CF",
  alt = false,
  eyebrow = "Así se vive cada episodio",
}) => (
  <Section alt={alt}>
    <Reveal className="mb-10 max-w-2xl">
      <Eyebrow color={accent}>{eyebrow}</Eyebrow>
      <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-ink">
        Seis actos, dos miradas.
      </h2>
      <p className="mt-4 text-ink/60 leading-relaxed">
        Cada episodio sigue el mismo ritmo de 6 actos. Aquí puedes ver cómo vive cada momento
        cada una: lo que diría Bella y lo que diría Anto en el mismo lugar.
      </p>
    </Reveal>

    <Stagger className="grid gap-5 lg:grid-cols-2" data-testid="format-dialogue-grid">
      {ACTS.map((a) => (
        <StaggerItem
          key={a.n}
          data-testid={`format-act-${a.n}`}
          className="rounded-[1.75rem] bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
        >
          <div className="flex items-baseline gap-4">
            <span className="font-display text-4xl font-extrabold tracking-tighter text-ink/15">
              {a.n}
            </span>
            <h3 className="font-display text-xl font-extrabold tracking-tight text-ink">
              {a.title}
            </h3>
          </div>
          <ActDialogue act={a} />
        </StaggerItem>
      ))}
    </Stagger>
  </Section>
);
